module.exports = __webpack_public_path__ + "img/211.beefbfc9.jpg";